import StaffModel from "@/models/lab/StaffModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class StaffCollection extends LabServiceCollection {
  model() {
    return StaffModel;
  }

}
